import React from 'react';

import { Typography } from 'components/shared/Typography';

import styles from './ImageBlock.module.scss';

const ImageBlock = ({ className, data }: { className: any; data: any }) => (
  <div className={className}>
    <img className={styles.preview} src={data.url} />
    {data.caption && (
      <Typography className={styles.caption}>{data.caption}</Typography>
    )}
  </div>
);

export default React.memo(ImageBlock) as any;
